import { FC } from "react";
import { Box, Stack } from "@mui/material";
import { AskAiConversationItem } from "@/store/ask-ai/utils/types";

interface AskAIQuestionProps {
  data: AskAiConversationItem;
}

export const AskAIQuestion: FC<AskAIQuestionProps> = ({ data }) => {
  return (
    <Stack
      bgcolor="grey.100"
      px={2}
      py={1}
      borderRadius={7}
      maxWidth="80%"
      alignSelf="flex-end"
    >
      <Box dangerouslySetInnerHTML={{ __html: data.text ?? "" }} />
    </Stack>
  );
};
